import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdvanceDateRangePickerComponent } from "./advance-daterangepicker.component";
import { NgxDaterangepickerMd } from "../../modules/daterangepicker";
import { FormsModule } from "@angular/forms";

@NgModule({
    imports: [ FormsModule, NgxDaterangepickerMd, CommonModule ],
    exports: [ AdvanceDateRangePickerComponent ],
    declarations: [ AdvanceDateRangePickerComponent ],
})
export class AdvanceDateRangeModule {}